export enum ServiceRequestStatus {
  WaitingPayment = 'waiting-payment',
  PendingApproval = 'pending-approval',
  Confirmed = 'confirmed',
  Completed = 'completed',
  Canceled = 'canceled',
  WaitingPaymentMethod = 'waiting-payment-method',
}
